import { NrlkClient } from "../model/client.js";
import { NrlkException } from "../model/exception.js";

export async function getClient(idClient) {
    try {
        const client = new NrlkClient();
        const data = await client.getClient();
        return data.data;
    } catch (error) {
        throw new NrlkException(error);
    }
}
